/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Teachingsubjectinterest2Inputs */

const en__field_teachingsubjectinterest2 = /** @type {(inputs: _Field_Teachingsubjectinterest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaching Subject Interest`)
};

const de__field_teachingsubjectinterest2 = /** @type {(inputs: _Field_Teachingsubjectinterest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt Fachinteresse`)
};

/**
* | output |
* | --- |
* | "Teaching Subject Interest" |
*
* @param {_Field_Teachingsubjectinterest2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_teachingsubjectinterest2 = /** @type {((inputs?: _Field_Teachingsubjectinterest2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Teachingsubjectinterest2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_teachingsubjectinterest2(inputs)
	return de__field_teachingsubjectinterest2(inputs)
});
export { _field_teachingsubjectinterest2 as "_field_teachingSubjectInterest" }